var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Flint.file('mframework/views/mmodal.js', function (require) {
    var _reactModal = require('react-modal');

    var _reactModal2 = _interopRequireDefault(_reactModal);

    Flint.view('MModal', function (view, on, $) {
      var pro = initPro(view, {
        contentStyle: M.mapAtom({}),
        overlayStyle: M.mapAtom({}),
        isOpen: M.defaultAtom(true),
        children: atom()
      });view.render(function () {
        return view.el(
          [_reactModal2.default, 'ReactModal', 1],
          {
            appElement: document.getElementById('_flintapp'),
            isOpen: pro.isOpen.get(),
            onRequestClose: view.props.onRequestClose,
            style: {
              content: IMap({
                top: null,
                bottom: null,
                left: null,
                right: null,
                position: null,
                display: 'flex',
                overflow: 'auto'
              }).merge(pro.contentStyle.get()).toJS(),
              overlay: IMap({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: null,
                zIndex: 100
              }).merge(pro.overlayStyle.get()).toJS()
            }
          },
          view.el(
            ['hack', 1],
            { id: '_flintapp' },
            pro.children.get()
          )
        );
      });

      // The <hack> tag addresses two problems:
      // 1. Flint's styles only work inside a tag with id="_flintapp"
      // 2. ReactModal.setAppElement appears to be totally broken.
      // Therefore we'll just wrap the modal's elements in a second
      // component with id="_flintapp".
    });
  })
})();
//# sourceMappingURL=mmodal.js.map
